module.exports = __webpack_public_path__ + "img/saham.f0743e5c.jpg";